// ** Third Party Components
import styled from "styled-components";
import { Swiper } from "swiperNew/react";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledCarouselSwiperNew = styled(Swiper)`
	position: relative;
	display: flex;
	height: 100%;

	width: 100%;

	.swiper-slide img {
		display: block;
		height: 100%;
		width: 100%;
		object-fit: contain;
		margin: 0 auto;
	}
`;

// #####################################################
